import { get, post } from "@utils/axios";

const api = "adms";

export const getAdmsMachinesReq = () => get(`${api}/machines`);
export const getAdmsUsersReq = (machineId) => get(`${api}/users?machine_id=${machineId}`);
export const getAdmsAttendanceReq = (payload) => {
  const query = new URLSearchParams({
    machine_id: payload.machine_id,
    ...(payload.from_date ? { from_date: payload.from_date } : {}),
    ...(payload.to_date ? { to_date: payload.to_date } : {}),
  }).toString();

  return get(`${api}/attendance?${query}`);
};
export const getAdmsCommandsReq = (machineId) => get(`${api}/commands?machine_id=${machineId}`);
export const getAdmsRequestsReq = (machineId) => get(`${api}/requests?machine_id=${machineId}`);
export const getAdmsMappingContextReq = (machineId, branchId) => {
  const query = new URLSearchParams({
    machine_id: machineId,
    ...(branchId ? { branch_id: branchId } : {}),
  }).toString();

  return get(`${api}/mapping-context?${query}`);
};

export const syncAdmsUsersReq = (payload) => post(`${api}/users/fetch`, payload);
export const previewAdmsEmployeeSyncReq = (payload) => post(`${api}/users/preview-employee-sync`, payload);
export const syncAdmsEmployeesReq = (payload) => post(`${api}/users/sync-employees`, payload);
export const upsertAdmsUserReq = (payload) => post(`${api}/users`, payload);
export const deleteAdmsUserReq = (payload) => post(`${api}/users/delete`, payload);
export const saveAdmsMappingsReq = (payload) => post(`${api}/mappings`, payload);
export const removeAdmsMappingReq = (payload) => post(`${api}/mappings/delete`, payload);
export const fetchAdmsAttendanceReq = (payload) => post(`${api}/attendance/fetch`, payload);
export const queueAdmsCommandReq = (payload) => post(`${api}/commands`, payload);
